import React, { useEffect, useState } from "react";
import billImg from "../images/bill.png";
import ClipLoader from "react-spinners/ClipLoader";
import jsPDF from "jspdf";
import moment from "moment";
import { Box, Stack, styled } from "@mui/system";
import PurchaseRepository from "../Repository/PurchaseRepository";
import { Typography } from "@mui/material";
import employeeLogo from "../images/employee.png";
import { toast } from "react-toastify";

const ItemBox = styled("div")({
  position: "relative",
  display: "grid",
  gridTemplateColumns: "10% 45% 45%",
  backgroundColor: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
  padding: "10px",
  margin: "15px",
  borderRadius: "5px",
});

function PurchaseOrdersReturn() {
  const [state, setState] = useState({
    orders: [],
    savedOrders: [],
    showOrder: false,
    Total: 0,
    loading: false,
    updateDialog: false,
    year: null,
    month: null,
    day: null,
    order: [],
  });

  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    let { data } = await PurchaseRepository.purchasesModel({
      request: {
        method: "getReturnPurchases",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setState((prev) => ({
      ...prev,
      loading: false,
      orders: data.response.data.purchases,
    }));
  };
  const totalPrice = (order) => {
    let Total = 0;
    order.items.map((item) => {
      let Qty = item.newQuantity ? parseInt(item.newQuantity) : 1;
      let itemPrice = item.salePrice
        ? parseInt(item.salePrice)
        : parseInt(item.price);
      Total += Qty * itemPrice;
    });
    return { Total: Total };
  };

  const print = (order) => {
    try {
      let doc = new jsPDF();

      doc.setFontSize(18);
      doc.setFontStyle("bold");
      doc.text(localStorage.getItem("company"), 105, 22);
      doc.setFontSize(26);
      doc.text("PURCHASE ORDER", 105, 35);

      doc.setFontSize(12);
      doc.setFontStyle("normal");

      doc.text("Date:", 150, 45);
      doc.text(moment.unix(order.created_at).format("dd-mm-yyyy"), 165, 45);

      doc.setFontSize(14);
      doc.setFontStyle("bold");
      doc.text("SHIP TO", 100, 48);

      doc.setFontSize(12);
      doc.setFontStyle("normal");
      doc.text(order.vendor?.dept || "", 20, 60);
      if (order.vendor) {
        let val1 = order.vendor.companyName
          ? order.vendor.companyName
          : order.vendor?.company;
        doc.text(val1, 20, 55);
        doc.text(order.vendor?.dept || "", 20, 60);
        doc.text(order.vendor?.street || "", 20, 65);
        doc.text(order.vendor?.city || "", 20, 70);
        doc.text(order.vendor?.phone || "", 20, 75);
        doc.text("VENDOR", 21, 48);
      } else {
        doc.text(order.ledger_detail?.name || "", 20, 55);
        doc.text(order.ledger_detail?.address || "", 20, 60);
        doc.text(order.ledger_detail?.ledgerType || "", 20, 65);
        doc.text("LEDGER", 21, 48);
      }
      let img = new Image();

      let baseUrl = localStorage.getItem("base_url");

      if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
        let snapshot = employeeLogo;
        img.src = snapshot;
      } else {
        let snapshot = localStorage.getItem("base_url");
        img.src = snapshot;
      }
      doc.addImage(img, "png", 0, 0, 40, 40);

      doc.text(order.ship?.name || "", 100, 55);
      doc.text(order.ship?.company || "", 100, 60);
      doc.text(order.ship?.street || "", 100, 65);
      doc.text(order.ship?.city || "", 100, 70);
      doc.text(order.ship?.phone || "", 100, 75);

      doc.setFontSize(14);
      doc.setFontStyle("bold");
      doc.text("Sr #", 21, 90);
      doc.text("Item", 40, 90);
      doc.text("Quantity", 140, 90);
      doc.text("Price", 170, 90);

      doc.cell(20, 84, 170, 8, " ");

      let y = 92;

      order?.items?.map((item, index) => {
        doc.setFontSize(14);
        doc.setFontStyle("bold");
        doc.cell(20, y, 12, 6, " ");
        doc.cell(32, y, 130, 6, " ");
        doc.cell(137, y, 25, 6, " ");
        doc.cell(162, y, 28, 6, " ");

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text((index + 1).toString(), 22, y + 5);
        doc.text(item.name, 34, y + 5);
        // doc.text(item.description, 69, y + 5);
        doc.text(
          item.purchaseQuantity || item.newQuantity.toString(),
          139,
          y + 5
        );
        console.log("item.price", item.price)
        doc.text(String(item.price), 170, y + 5);

        doc.setFontSize(10);

        doc.text(localStorage.getItem("terms") || "", 58, 270);

        doc.text("Powered by www.hardwarepakistan.com", 68, 280);
        doc.text("0342-5588269", 88, 290);
        y = y + 6;

        if (y >= 240) {
          doc.addPage();
          y = 20;
        }
      });





      y = y + 8;

      doc.cell(20, y, 100, 8, " ");
      doc.cell(20, y + 8, 100, 30, " ");

      doc.setFontSize(14);
      doc.text("Comments Or Special Instructions", 22, y + 6);
      doc.text("SUB TOTAL", 138, y);
      doc.text(totalPrice(order).Total.toString(), 168, y);

      doc.text("TAX", 138, y + 7);
      doc.text("SHIPPING", 138, y + 14);
      doc.text("OTHER", 138, y + 21);

      y = y + 23;

      doc.line(137, y, 190, y, "S");

      doc.text("TOTAL", 138, y + 6);
      doc.text(totalPrice(order).Total.toString(), 168, y + 6);
      if (window.innerWidth <= 600) {
        doc.save("reciept");
      } else {
        doc.autoPrint();
      }
      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
      toast.configure();
      toast.error("Error");
    }
  };

  return (
    <Box sx={{ mt: { md: 3, xs: "40px" }, mb: 2, pb: 3 }}>
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          color: "#4EAF51",
          fontSize: { md: "2.125rem", xs: "16px" },
        }}
      >
        RETURNED FINALIZED ORDERS
      </Typography>

      {state.orders.map((order, index) => {
        return (
          <ItemBox key={index}>
            <img
              src={billImg}
              className="w-h-50"
              onClick={() => print(order)}
              style={{ cursor: "pointer" }}
            />
            <Typography
              variant="h6"
              sx={{
                mt: 2,
                color: "#757575",
                fontSize: { md: "1.5rem", xs: "14px" },
                ml: { md: "0px", xs: "30px" },
              }}
            >
              Order # {state.orders.length - index}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                color: "#757575",
                fontSize: { md: "1.5rem", xs: "14px" },
              }}
            >
              {order.ledger_detail
                ? order.ledger_detail?.name
                : order.vendor?.companyName}
            </Typography>
          </ItemBox>
        );
      })}
      <Stack direction="row" justifyContent="center">
        <ClipLoader size={50} color={"#4DAF51"} loading={state.loading} />
      </Stack>
    </Box>
  );
}

export default PurchaseOrdersReturn;
